import type { ReactNode } from 'react';

export interface FooterAction {
  label: string;
  onClick: () => void;
  disabled?: boolean;
  /** Red "!" badge on the button (e.g. Continue with unresolved attention items). */
  alert?: boolean;
  /** Render gold instead of black — the mobile bar's real "Add to cart" step
   *  (owner 2026-07-27). Desktop Footer ignores this. */
  gold?: boolean;
}

export interface FooterProps {
  /** Left status text (e.g. "8 photos · 1 resolution warning"). */
  status?: ReactNode;
  statusWarn?: boolean;
  secondary?: FooterAction;
  /** Highlighted gold action between secondary and primary (Step 2 "Add to cart"). */
  accent?: FooterAction;
  primary?: FooterAction;
}

/** Desktop footer action bar: status left, secondary + accent + primary buttons right. */
export function Footer({ status, statusWarn, secondary, accent, primary }: FooterProps) {
  return (
    <footer className="footbar">
      <span className={`footbar__status${statusWarn ? ' footbar__status--warn' : ''}`}>{status}</span>
      <div className="footbar__actions">
        {secondary && (
          <button
            type="button"
            className="btn btn--secondary"
            onClick={secondary.onClick}
            disabled={secondary.disabled}
          >
            {secondary.label}
          </button>
        )}
        {accent && (
          <button
            type="button"
            className="btn btn--gold footbar__accent"
            onClick={accent.onClick}
            disabled={accent.disabled}
          >
            {accent.label}
          </button>
        )}
        {primary && (
          <button
            type="button"
            className="btn btn--primary footbar__primary"
            onClick={primary.onClick}
            disabled={primary.disabled}
          >
            {primary.label}
            {primary.alert && (
              <span className="footbar__alert" role="img" aria-label="Some prints need your attention">
                !
              </span>
            )}
          </button>
        )}
      </div>
    </footer>
  );
}
